import { Button as DefaultButton } from 'components';
import styled from 'styled-components';

export const Description = styled.p`
  font-size: 1.25rem;
  line-height: 1.5;
`;

export const Button = styled(DefaultButton)``;
